/**
 * Normalize Mongo ObjectId values that arrive as strings, extended
 * JSON, or plain objects from SSE / REST JSON payloads.
 */
export const normalizeEntityId = (raw: unknown): string => {
  if (raw == null) return '';
  if (typeof raw === 'string') return raw;
  if (typeof raw === 'object') {
    const record = raw as Record<string, unknown>;
    if (typeof record.$oid === 'string') return record.$oid;
    if (typeof record._id === 'string') return record._id;
    if (record._id != null && typeof record._id === 'object') {
      return normalizeEntityId(record._id);
    }
    if (typeof (record as { toHexString?: () => string }).toHexString === 'function') {
      return (record as { toHexString: () => string }).toHexString();
    }
    const asString = String(raw);
    if (/^[a-fA-F0-9]{24}$/.test(asString)) return asString;
  }
  return String(raw);
};
